import { createModule } from 'redux-modux'

const initialState = {
  productRecommendList: [],
  productList: { list: [], total: 0 },
  shoppingCartProductList: {
    list: []
  },
  sortShoppingCart: 'ITEM',
  shoppingProductGroup: [],
  shoppingProductBrand: []
}

const setDataList = (state, action) => ({
  ...state,
  ...action.data
})

const setProdutRecommentList = (state, actions) => ({
  ...state,
  productRecommendList: actions.data
})

const setProdutList = (state, actions) => ({
  ...state,
  productList: actions.data
})

const setShoppingCartProductList = (state, actions) => ({
  ...state,
  shoppingCartProductList: actions.data
})

const setShoppingProductGroup = (state, actions) => ({
  ...state,
  shoppingProductGroup: actions.data
})

const setShoppingProductBrand = (state, actions) => ({
  ...state,
  shoppingProductBrand: actions.data
})

const handlers = {
  setDataList,
  setProdutRecommentList,
  setProdutList,
  setShoppingCartProductList,
  setShoppingProductGroup,
  setShoppingProductBrand
}

export default createModule({ moduleName: 'list', initialState, handlers })